import apiClient from '@u/apiClient'
import CheckVatNumberController from '@/wayfinder/actions/App/Http/Controllers/Vat/CheckVatNumberController'
import LookupCompanyByVatController from '@/wayfinder/actions/App/Http/Controllers/Vat/LookupCompanyByVatController'

export default {
  checkVAT({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CheckVatNumberController.get(), { params: payload })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getCompanyInfoByVat({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(LookupCompanyByVatController.get(), { params: payload })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
